import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import footer from './assets/footer.png';

const Wrapper = styled.div`
  padding: 0 var(--double-unit) 10vh;
  @media ${laptopAndAbove} {
    background: url(${footer});
    background-size: cover;
    background-repeat: no-repeat;
    background-position:
      bottom 20% center,
      top center;
    align-items: center;
    justify-content: center;
    text-align: center;
    display: grid;
    padding: var(--quadruple-unit);
    grid-template-columns: 1fr fit-content(calc(100 * var(--unit))) 1fr;
    > * {
      grid-column: 2;
    }
    min-height: 1060px;
  }
`;

const Title = styled.h1`
  font-size: clamp(var(--fs-32), 8vw, 80px); /** 80 / 1920 * 100 = 4.16 */
  font-weight: normal;
`;

type Props = {
  onCreate: (arg: unknown) => void;
};
export const Footer = ({ onCreate }: Props) => {
  return (
    <Wrapper>
      <Vertical gap={3}>
        <Title>
          <FormattedMessage
            id="RivalsLeagues.Footer.title"
            defaultMessage="You think you and your friends know football?"
          />
        </Title>
        <Horizontal center>
          <Button color="secondary" size="medium" onClick={onCreate}>
            <FormattedMessage
              id="RivalsLeagues.Footer.cta1"
              defaultMessage="Prove it"
            />
          </Button>
        </Horizontal>
      </Vertical>
    </Wrapper>
  );
};
